import './Radio.scss'

import React from 'react';
import PropTypes from 'prop-types';

import Label from 'components/Label';

export default class Radio extends React.Component {
    static propTypes = {
        checked: PropTypes.bool.isRequired,
        disabled: PropTypes.bool,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired
    };

    render() {
        let { className, ...otherProps } = this.props;
        return (
            <div className="o-radio">
                <input
                    className={`c-radio ${className || ''}`}
                    type="radio"
                    {...otherProps}
                />
                <Label htmlFor={this.props.id}>{this.props.label}</Label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Radio/index.js